import React from 'react';
import { Input, Label, FormGroup } from 'reactstrap';
import CustomGrouping from './CustomGrouping';
import EachAnswerGrouping from './EachAnswerGrouping';
import {
  GROUPING_MODE,
  GROUPING_MODE_OPTIONS,
  groupingModeOption,
} from './grouping-utils';
import styles from './Grouping.module.scss';

export default function BreakoutGrouping({
  answers = [],
  groupingMode = GROUPING_MODE.EACH_ANSWER,
  groups = {},
  onGroupingModeChange,
  onGroupsChange,
  disabled = false,
}) {
  const selected = groupingModeOption(groupingMode);

  return (
    <div className={styles.root}>
      <FormGroup>
        <Label for="grouping_mode">Grouping</Label>
        <Input
          id="grouping_mode"
          type="select"
          className="limited-width-lg"
          value={groupingMode}
          onChange={(e) => onGroupingModeChange?.(e.target.value)}
          disabled={disabled}
        >
          {GROUPING_MODE_OPTIONS.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </Input>
      </FormGroup>
      {selected?.description ? (
        <p className={styles.hint}>{selected.description}</p>
      ) : null}
      {groupingMode === GROUPING_MODE.CUSTOM ? (
        <CustomGrouping
          answers={answers}
          groups={groups}
          onChange={onGroupsChange}
          disabled={disabled}
        />
      ) : (
        <EachAnswerGrouping answers={answers} />
      )}
    </div>
  );
}
